export default __webpack_public_path__ + "static/media/floorplan.e86d72ab.webp";